























































































































































































import { AxiosResponse } from "axios";
import { Dictionary } from "lodash";
import moment from "moment";
import {
  ValidationObserver,
  ValidationProvider
} from "vee-validate";
import VueI18n from "vue-i18n";
import { Component, Ref, Vue, Watch } from "vue-property-decorator";
import {
  ApiMessage, CustomersApi, FailureTrackingsApi, GetFailureTrackingResponse, LocationsApi, PostFailureTrackingRequest, PutFailureTrackingRequest, UnitsApi
} from "../../../apis";


enum ACTION {
  NEW = "NEW",
  EDIT = "EDIT",
  VIEW = "VIEW",
}
@Component({
  components: { ValidationObserver, ValidationProvider },
})
export default class FailureTrackingForm extends Vue {
  currentMode: ACTION = null;
  selectedID: string = "";
  failureTracking = {} as
    | PutFailureTrackingRequest
    | PostFailureTrackingRequest;
  isViewMode = false;
  statusTrans: string | VueI18n.TranslateResult = "";

  isShowProductDialog = false;
  readonly NEW = ACTION.NEW;
  readonly EDIT = ACTION.EDIT;

  //General Options
  customerOptions = [];
  locationOptions = [];
  unitOptions = [];

  @Ref("observer") readonly observer!: InstanceType<typeof ValidationObserver>;
  showConfirmDialog: boolean = false;

  created() {
    this.currentMode =
      (this.$route.name === "add-failure-tracking" && ACTION.NEW) ||
      (this.$route.name === "edit-failure-tracking" && ACTION.EDIT) ||
      (this.$route.name === "view-failure-tracking" && ACTION.VIEW);
    if (this.currentMode === ACTION.EDIT || this.currentMode === ACTION.VIEW) {
      this.selectedID = this.$route.params.id;
    }
    this.isViewMode = this.currentMode === ACTION.VIEW;
  }

  mounted() {
    this.initForm();
  }

  async initForm() {
    let customersRes;
    try {
      this.$util.showLoading();
      [customersRes] = await Promise.all([
        new CustomersApi().getAllCustomerByStringAndStatus({
          keyword: "",
          status: "Active",
        }),
      ]);
    } catch (error) {
      this.$util.showError(error);
      return;
    } finally {
      this.$util.hideLoading();
    }

    // dropdown builder
    this.customerOptions = customersRes.data.data;

    if (
      (this.currentMode === ACTION.EDIT || this.currentMode === ACTION.VIEW) &&
      this.selectedID
    ) {
      await this.onGetFailureTrackingById(this.selectedID);
    } else {
      this.failureTracking = {} as PostFailureTrackingRequest;
    }
  }

  async onGetFailureTrackingById(selectedID) {
    let failureTracking: AxiosResponse<GetFailureTrackingResponse>;
    try {
      this.$util.showLoading();
      failureTracking = await new FailureTrackingsApi().getFailureTracking({
        id: selectedID,
      });
    } catch (error) {
      this.$util.showError(error);
      return;
    } finally {
      this.$util.hideLoading();
    }
    const failureTrackingRes = failureTracking.data.data;
    this.failureTracking = {
      customer: failureTrackingRes.customer.id,
      location: failureTrackingRes.location.id,
      unit: failureTrackingRes.unit.id,
      status: failureTrackingRes.status,
      failureName: failureTrackingRes.failureName,
      describe: failureTrackingRes.describe,
      causeOfFailure: failureTrackingRes.causeOfFailure,
      solution: failureTrackingRes.solution,
      remark: failureTrackingRes.remark,
      dateOpen: moment(failureTrackingRes.dateOpen).format("YYYY-MM-DD HH:mm"),
      dateClosed: moment(failureTrackingRes.dateClosed).format(
        "YYYY-MM-DD HH:mm"
      ),
    };
    this.statusTrans = this.$t(`status.${failureTrackingRes.status.replace(/\s/g, '').toUpperCase()}`);
    await Promise.all([this.onChangeCustomer(), this.onChangeLocation()]);
  }

  get saveFailureTrackingClick() {
    return this.$store.getters.saveFailureTrackingClick;
  }

  @Watch("saveFailureTrackingClick")
  onSaveFailureTrackingClick() {
    this.onSubmit();
  }

  async onSubmit() {
    const isValidDate = this.doCheckValidDate();
    const isValid =
      (await (this.$refs.observer as any).validate()) && isValidDate;
    if (!isValid) {
      this.$util.goToErrorField(this.observer);
      return;
    }
    this.$util.showLoading();
    await this.doSubmit()
      .then((res) => this.handleSuccess())
      .catch((err) => this.handleFailed(err));
    this.$util.hideLoading();
  }

  invalidMsgStartDate = null;
  invalidMsgEndDate = null;

  doCheckValidDate(): boolean {
    const startDate = moment(this.failureTracking.dateOpen);
    const endDate = moment(this.failureTracking.dateClosed);
    if (startDate > endDate) {
      this.invalidMsgEndDate = this.$t("message.invalid_end_date");
      return false;
    }
    this.invalidMsgStartDate = "";
    this.invalidMsgEndDate = "";
    return true;
  }

  doSubmit(): Promise<AxiosResponse> {
    const formatDate = (dateStr) =>
      dateStr
        ? moment(dateStr, "YYYY-MM-DD HH:mm").utc().format("YYYY-MM-DD HH:mm")
        : undefined;
    const body: PutFailureTrackingRequest | PostFailureTrackingRequest = {
      ...this.failureTracking,
      dateOpen: formatDate(this.failureTracking.dateOpen),
      dateClosed: formatDate(this.failureTracking.dateClosed),
    };
    if (this.currentMode === ACTION.EDIT && this.selectedID) {
      return new FailureTrackingsApi().updateFailureTracking({
        id: this.selectedID,
        putFailureTrackingRequest: body as PutFailureTrackingRequest,
      });
    } else {
      return new FailureTrackingsApi().createFailureTracking({
        postFailureTrackingRequest: body as PostFailureTrackingRequest,
      });
    }
  }

  handleSuccess() {
    this.$router.push({ name: "failure-tracking" });
  }

  handleFailed(err) {
    this.$util.showError(err);
  }

  get apiMessages(): Dictionary<ApiMessage[]> {
    return this.$store.getters.apiMessages;
  }

  @Watch("apiMessages", { deep: true })
  apiMessagesWatch(messages: Dictionary<ApiMessage[]>) {
    this.$util.showApiError(messages, this.observer);
  }

  async onChangeCustomer() {
    this.locationOptions = [];
    this.unitOptions = [];
    if (!this.failureTracking.customer) return;
    try {
      this.$util.showLoading();
      const res = await new LocationsApi().getLocationsWithCustomer({
        customerId: this.failureTracking.customer,
      });
      this.locationOptions = res.data.data;
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  async onChangeLocation() {
    this.unitOptions = [];
    if (!this.failureTracking.location) return;
    try {
      this.$util.showLoading();
      const res = await new UnitsApi().getUnitByLocationId({
        locationId: this.failureTracking.location,
      });
      this.unitOptions = res.data.data;
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  get closeFailureClick() {
    return this.$store.getters.closeFailureClick;
  }

  @Watch("closeFailureClick")
  onExportClick() {
    this.selectedID = this.$route.params.id;
    this.showConfirmDialog = true;
  }

  async doClose() {
    this.$util.showLoading();
    try {
      await new FailureTrackingsApi().closeFailureTracking({
        id: this.selectedID,
      });
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
      this.handleSuccess();
    }
  }
}
